/**
 * "Add to cart" button price: price × quantity + Kaching Subscriptions sync.
 *
 * The theme's buy button (<product-buy-price>) shows the price of one unit of
 * the selected variant. This script shows the live total instead:
 *
 * - Kaching Bundles deals on the product: left untouched (Kaching sets the
 *   quantity and the bundle price itself).
 * - Kaching Subscriptions widget: the selected plan price shown by Kaching,
 *   which already includes the quantity (Kaching's original snippet).
 * - Otherwise: variant price × selected quantity.
 *
 * Products added with the theme's Product bundle block are added on top.
 *
 * Scoped per product, so a quick view or featured product is never mixed up
 * with another product on the page.
 */
(function () {
  var PRICE_SEL = '.kaching-subscriptions__card-wrapper.selected .kaching-subscriptions__card-price';
  var FALLBACK_SEL = '.kaching-subscriptions__card-price';
  var ATC_SEL = 'product-buy-price';
  var KACHING_BUNDLES_SEL = 'kaching-bundle .kaching-bundles__bar';
  var queued = false;

  /* Extra amount (cents) per product form from the theme's Product bundle block */
  var bundleExtras = {};

  function scopeOf(el) {
    return el.closest('product-info') || el.closest('.shopify-section') || null;
  }

  function moneyFormat() {
    var settings = window.theme && window.theme.settings;
    if (!settings) return null;
    return settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
  }

  function formatMoney(cents) {
    var format = moneyFormat();
    if (!format || !window.theme.Currency) return null;
    return window.theme.Currency.formatMoney(cents, format);
  }

  /* Reads a price shown in the store's money format (e.g. "1,629 kr", "€78,95") as cents */
  function parseMoney(text) {
    var format = moneyFormat() || '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var decimals = placeholder.indexOf('no_decimals') !== -1 ? 0 : 2;
    var decimalSeparator = /comma_separator/.test(placeholder) ? ',' : '.';

    var number = String(text).replace(/[^\d.,]/g, '');
    if (decimals === 0) {
      number = number.replace(/[.,\s]/g, '');
    } else {
      var thousands = decimalSeparator === ',' ? /\./g : /,/g;
      number = number.replace(thousands, '').replace(decimalSeparator, '.');
    }

    var value = parseFloat(number);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function quantityFor(el, scope) {
    var formId = el.getAttribute('form');
    var input = (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]')) ||
      scope.querySelector('input[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity > 0 ? quantity : 1;
  }

  function totalFor(el, scope) {
    var src = scope.querySelector(PRICE_SEL) || scope.querySelector(FALLBACK_SEL);
    if (src) {
      /* Kaching's subscription price already reflects the selected quantity */
      var kachingPrice = parseMoney(src.textContent.trim());
      if (kachingPrice !== null) return kachingPrice;
    }
    return (parseInt(el.getAttribute('data-price'), 10) || 0) * quantityFor(el, scope);
  }

  function sync() {
    queued = false;

    document.querySelectorAll(ATC_SEL).forEach(function (el) {
      var scope = scopeOf(el);
      if (!scope || scope.querySelector(KACHING_BUNDLES_SEL)) return;

      var total = totalFor(el, scope) + (bundleExtras[el.getAttribute('form')] || 0);
      var formatted = formatMoney(total);
      if (!formatted) return;

      if (el.textContent.trim() !== formatted.trim()) el.innerHTML = formatted;
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  function onBundleChange(event) {
    var form = event.target && event.target.id;
    if (!form || !event.detail || !event.detail.items) return;

    bundleExtras[form] = event.detail.items.reduce(function (total, item) {
      return total + (parseInt(item.price, 10) || 0) * (parseInt(item.quantity, 10) || 0);
    }, 0);
    queue();
  }

  function init() {
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', queue);
    document.addEventListener('input', queue);
    document.addEventListener('click', queue);
    /* bundle:change does not bubble: listen in the capture phase */
    document.addEventListener('bundle:change', onBundleChange, true);
    queue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
